import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Ruta privada a la que solo se puede acceder si el usuario está autenticado
 *
 * @param {Object} props - Propiedades del componente
 * @param {React.Component} props.children - Componente hijo
 * @param {Boolean} props.isAuthenticated - Autenticación
 * @returns {React.Component} Ruta privada
 */
export const PrivateRoute = ({ children, isAuthenticated }) => {
  return isAuthenticated ? children : <Navigate to="/auth/login" />;
};
